import { InteractionRequiredAuthError } from '@azure/msal-browser'

import { entraTokenRequest } from '@/lib/msalConfig'
import { msalInstance } from '@/lib/msalInstance'

/**
 * Adquiere el access token de Entra ID para la API.
 * Intenta refresh silencioso primero; si requiere interacción usa popup.
 */
export async function acquireEntraAccessToken(): Promise<string> {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length === 0) {
    throw new Error('No hay sesión de Entra ID activa')
  }

  const request = { ...entraTokenRequest, account: accounts[0] }

  try {
    const result = await msalInstance.acquireTokenSilent(request)
    return result.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      const result = await msalInstance.acquireTokenPopup(request)
      return result.accessToken
    }
    throw error
  }
}

/**
 * Retorna true si hay al menos una cuenta de Entra ID activa en MSAL.
 */
export function hasActiveEntraSession(): boolean {
  return msalInstance.getAllAccounts().length > 0
}
